/**
 * TextSubheading, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/TextSubheadingComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

export const TextSubheadingCore = {
  type: 'TextSubheading',
  name: 'Text Subheading',
  icon: '📄',
  description: 'Smaller heading to label a section below the main title.',
  category: 'display',
  maxPerScreen: null,
  getDefaultProperties() {
    return {
      text: 'Subheading Text',
      visible: true,
    };
  },
  getPropertySchema() {
    return {
      text: {
        type: 'string',
        label: 'Text',
        required: true,
        maxLength: 80,
      },
      visible: {
        type: 'boolean',
        label: 'Visible',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];

    if (!properties.text || properties.text.trim().length === 0) {
      errors.push('Subheading text is required');
    }

    if (properties.text && properties.text.length > 80) {
      errors.push('Subheading text must be 80 characters or less');
    }

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    return {
      type: 'TextSubheading',
      text: properties.text,
    };
  },
  transformFromWhatsApp(whatsappComponent) {
    return {
      text: whatsappComponent.text,
      visible: true,
    };
  },
};
